import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { VacationProvider } from './features/vacation';
import { DemoProvider } from './context/DemoContext';
import { App } from './App';
import './index.css';

// Force dark mode on the root element immediately
document.documentElement.classList.remove('light');
document.documentElement.classList.add('dark');

// Clear profile storage on fresh load if needed
const stored = localStorage.getItem('profile-storage');
if (!stored || stored === '{}' || stored === 'undefined') {
  localStorage.removeItem('profile-storage');
}

// Get root element
const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Create app
createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <DemoProvider>
          <VacationProvider>
            <App />
          </VacationProvider>
        </DemoProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);